export enum ProfileSections {
  ManageAccount = 'manageAccount',
  Faq = 'faq',
  Support = 'support',
  AppLanguage = 'appLanguage',
  About = 'about',
  Logout = 'logout',
  ManageSubscription = 'manageSubscription',
  CancelSubscription = 'cancelSubscription',
  PostChangeSubscription = 'postChangeSubscription',
}
